import React from 'react';
import { Container } from 'react-bootstrap';
import { ScholarshipSources, Title } from 'components'
import styled from 'styled-components';
import { device } from 'utils/device';

const PageContainer = ({ title, children, showSources = false }) => (
  <StyledContainer>
    <Title>{title}</Title>
    {children}
    {showSources && (
      <ScholarshipSources className="mt-3" divider showPublicTaxRecord={false} />
    )}
  </StyledContainer>
);

const StyledContainer = styled(Container)`
  margin: 2rem auto;
  max-width: 80%;

  @media ${device.tablet} {
    max-width: 95%;
  }
`;

export default PageContainer;
